import { axios } from '@/api/common'
import { FeatureFlagsResponse, FeatureFlagsResponseSchema } from './get.schema'
import { queryOptions } from '@tanstack/react-query'

export async function fetchFeatureFlags(): Promise<FeatureFlagsResponse> {
  const response = await axios.get('/api/feature-flags')
  return FeatureFlagsResponseSchema.parse(response.data)
}

export const featureFlagsQueryOptions = () =>
  queryOptions({
    queryKey: ['feature-flags'],
    queryFn: fetchFeatureFlags,
    staleTime: 5 * 60 * 1000, // 5 minutes - flags don't change frequently
    gcTime: 10 * 60 * 1000, // 10 minutes - keep in cache longer
    retry: 3, // Retry on failure
    retryDelay: 1000, // 1 second between retries
  })
